import { FILTER_TIME_OPTIONS, MAX_X_CHART_LABELS } from '../constants';

export const getXAxisConfigNewsViewChart = (labels, selectedTime, maxLabel = MAX_X_CHART_LABELS) => {
    if (selectedTime == FILTER_TIME_OPTIONS.ALL_MONTH || selectedTime == FILTER_TIME_OPTIONS.LAST_YEAR) {
        maxLabel = 6;
    }
    else if (selectedTime == FILTER_TIME_OPTIONS.ALL_WEEK) {
        maxLabel = 4;
    }

    const count = labels.length;
    if (count === 0) return { tickValues: [] };
    if (count <= maxLabel) return { tickValues: labels };
    
    const step = Math.ceil(count / (maxLabel - 1));
    const resultTicks = [];

    for (let i = 0; i < count; i += step) {
        resultTicks.push(labels[i]);
    }
    
    const lastLabel = labels[count - 1];
    if (!resultTicks.includes(lastLabel)) {
        resultTicks.push(lastLabel);
    }
    
    return {
        tickValues: resultTicks 
    };
};

export const formatXAxisLabel = (value, selectedTime, visibleTicks) => {
    const date = new Date(value);
    const currentYear = date.getFullYear();
    const sTime = Number(selectedTime);
    
    let shouldShowYear = false;
    
    if (visibleTicks) {
        const tickIndex = visibleTicks.indexOf(value);
        if (tickIndex === 0) {
            shouldShowYear = true;
        } else {
            const prevTickDate = new Date(visibleTicks[tickIndex - 1]);
            
            if (currentYear !== prevTickDate.getFullYear()) {
                shouldShowYear = true;
            }
            if (sTime === FILTER_TIME_OPTIONS.ALL_WEEK) {
                const prevEndDate = prevTickDate;
                prevEndDate.setDate(prevEndDate.getDate() + 6);
                if (currentYear === prevEndDate.getFullYear()) {
                    shouldShowYear = false;
                }
            }
        }
    }

    if (sTime === FILTER_TIME_OPTIONS.LAST_YEAR) {
        return formatDateWithStime(date, sTime, shouldShowYear);
    }

    if (sTime === FILTER_TIME_OPTIONS.ALL_WEEK) {
        const startDate = date;
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6);
        let showYearOnEnd = false;
        if (!shouldShowYear && startDate.getFullYear() !== endDate.getFullYear()) {
            showYearOnEnd = true;
        }

        const startStr = formatDateWithStime(startDate, sTime, shouldShowYear);
        const endStr = formatDateWithStime(endDate, sTime, showYearOnEnd);
        return `${startStr} ~\n${endStr}`;
    }
    
    return formatDateWithStime(date, sTime, false);
};

export const formatXAxisLabelNewsChart = (value, index, config, selectedTime, allLabels) => {
    const startDate = new Date(value);
    const sTime = Number(selectedTime);
    const displayedTicks = config?.tickValues || [];
    
    let showYearOnStart = value === displayedTicks[0];
    
    const currentTickIndex = displayedTicks.indexOf(value);
    if (currentTickIndex > 0) {
        const prevTickValue = displayedTicks[currentTickIndex - 1];
        const prevDate = new Date(prevTickValue);
        
        if (startDate.getFullYear() !== prevDate.getFullYear()) {
            showYearOnStart = true;
        }
    }
    
    if (sTime === FILTER_TIME_OPTIONS.LAST_YEAR) {
        return formatDateWithStime(startDate, sTime, showYearOnStart);
    }
    
    if (sTime === FILTER_TIME_OPTIONS.ALL_WEEK) {
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6);
        let showYearOnEnd = false;
        
        if (!showYearOnStart && startDate.getFullYear() !== endDate.getFullYear()) {
            showYearOnEnd = true;
        }

        const startStr = formatDateWithStime(startDate, sTime, showYearOnStart);
        const endStr = formatDateWithStime(endDate, sTime, showYearOnEnd);
        return `${startStr} ~\n${endStr}`;
    }
    
    return formatDateWithStime(startDate, sTime, false);
};

export const formatXAxisTooltip = (value, index, selectedTime) => {
    const startDate = new Date(value);
    const sTime = Number(selectedTime);
    
    if (sTime === FILTER_TIME_OPTIONS.ALL_WEEK) {
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6);

        const startStr = formatDateWithStime(startDate, sTime);
        const endStr = formatDateWithStime(endDate, sTime);
        return `${startStr} ~\n${endStr}`;
    }
    
    return formatDateWithStime(startDate, sTime);
};

const formatDateWithStime = (date, sTime, includeYear = true) => {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString();
    const d = date.getDate().toString();
    if (sTime === FILTER_TIME_OPTIONS.ALL_MONTH) {
        return `${y}/${m}`;
    }
    return includeYear ? `${y}/${m}/${d}` : `${m}/${d}`;
};

const getScale = (count) => {
    count = Number(count);        
    if (count >= 60) {
        return '0.5';
    }
    if (count >= 40) {
        return '0.6';
    }
    if (count >= 30) {
        return '0.7';
    }
    return '0.8';
}

export const getMarkElementStyle = (color, labelsCount, showOnlyEndPoints = false) => {
    const baseStyle = {
        display: 'inline',
        fill: color,
        stroke: color,
        scale: getScale(labelsCount),
    };

    if (showOnlyEndPoints) {
        return {
        display: 'none',
        '&:first-of-type, &:last-of-type': baseStyle,
        };
    }

    return baseStyle;
};

export const calculateOptimalStep = (chartWidth, totalLabels, selectedTime, fontSize = 12) => {
    const sTime = Number(selectedTime);
    const groupFilterOptions1 = [
        Number(FILTER_TIME_OPTIONS.THIS_MONTH),
        Number(FILTER_TIME_OPTIONS.LAST_MONTH),
        Number(FILTER_TIME_OPTIONS.LAST_30_DAYS),
    ];
    const groupFilterOptions2 = [
        Number(FILTER_TIME_OPTIONS.ALL_WEEK),
        Number(FILTER_TIME_OPTIONS.ALL_MONTH)
    ];

    if (groupFilterOptions1.includes(sTime)) {
        return 1;
    }

    let avgLabelCharCount = 5
    if (groupFilterOptions2.includes(sTime)) {
        avgLabelCharCount = 6
    }
    const estimatedLabelWidth = avgLabelCharCount * (fontSize * 0.6);
    const minGap = 20;
    const maxPossibleLabels = Math.floor(chartWidth / (estimatedLabelWidth + minGap));
    const step = Math.max(1, Math.ceil(totalLabels / maxPossibleLabels));
    return step;
};